<template lang="pug">
  b-container(fluid="lg")
    DeliveryStateCards.mb-2
    StoreMessages.mb-2
    ListPickupRequests(ref="listPickupRequests")    
</template>
<script>
import ListPickupRequests from '../components/pickupRequests/ListPickupRequests'
import DeliveryStateCards from '../components/delivery/DeliveryStateCards'
import StoreMessages from '../components/delivery/StoreMessages'

export default {
  components: {
    ListPickupRequests,
    DeliveryStateCards,
    StoreMessages,
  }

}
</script>